import { inject, Injectable } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import type { Observable } from 'rxjs';

import type { TypedFormControl, TypedFormGroup } from '@core/common-legacy';
import type { NotificationRef, NotificationStyle } from '@core/user-interface-legacy';
export enum AuthenticationVerificationType {
  PASSWORD,
  EMAIL_CODE,
}

export type AuthenticationFormGroup = TypedFormGroup<{
  emailCode: TypedFormControl<string>;
  password: TypedFormControl<string>;
}>;

export type User = {
  photoThumbUrl: string;
  firstName: string;
  lastName: string;
  email: string;
  initials: string;
  hasAvatar: boolean;
};

@Injectable()
export abstract class AuthenticationDialogService {
  protected readonly formBuilder = inject(UntypedFormBuilder);

  public errorMessages: Record<keyof AuthenticationFormGroup['controls'], Record<string, string>>;
  public notificationStyle: {
    [k: string]: { style: NotificationStyle; title: string; message: string };
  };
  public initialVerificationType: AuthenticationVerificationType =
    AuthenticationVerificationType.EMAIL_CODE;
  public user: User;
  public canChangeVerificationType: boolean = true;
  public passwordUsageDisabled: boolean;

  public createAuthForm(): AuthenticationFormGroup {
    return <AuthenticationFormGroup>this.formBuilder.group({
      password: ['', Validators.required],
      emailCode: [
        '',
        Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
      ],
    });
  }

  public abstract submit(form: AuthenticationFormGroup, skipCompany: boolean): Observable<string>;
  public abstract createEmailCodeProgressNotification(): NotificationRef;
  public abstract requestEmailCode(): Observable<void>;
}
